<!-- Falls es wirklich ein Bildpfad ist (z.B. aus assets/) -->
<ng-container *ngIf="dbIcon?.endsWith('.png'); else primeIconTemplate">
  <img [src]="dbIcon" [pTooltip]="typeName" tooltipPosition="top" alt="icon" class="activity-icon"
    [ngStyle]="{ width: '30px', height: '17px' }" />
</ng-container>

<!-- Falls es ein PrimeIcon ist (der Normalfall) -->
<ng-template #primeIconTemplate>
  <i [ngClass]="dbIcon?.includes('pi-') ? dbIcon : 'pi pi-' + dbIcon" [style.color]="dbColor" [pTooltip]="typeName">
  </i>
</ng-template>